<template>
    <div>
        <div class="sm:hidden mt-2">
            <label for="tabs" class="sr-only"> Vyberte sekci </label>
            <select @change="changeTab" v-model="tab" id="tabs" name="tabs" class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
                <option :value="'profile.show'"> Uživatelský účet </option>

                <option :value="'settings.isds'"> Datové schránky </option>

                <option :value="'settings.ds'"> Funkce DSchránky </option>

                <option :value="'spark.portal'"> Licence a platby </option>

                <option :value="'settings.notifications'"> Upozornění a maily </option>
            </select>
        </div>
        <div class="hidden sm:block bg-white">
            <div class="border-b border-gray-200 mx-2">
                <nav class="-mb-px flex space-x-8 justify-center" aria-label="Tabs">
                    <InertiaLink :class="tab === 'profile.show' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                  :href="route('profile.show')"
                                  class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm">

                        <svg :class="tab === 'profile.show' ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500'" class="-ml-0.5 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                        </svg>
                        <span> Uživatelský účet </span>
                    </InertiaLink>

                    <InertiaLink :class="tab === 'settings.isds' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                  :href="route('settings.isds')"
                                  class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm">

                        <svg :class="tab === 'settings.isds' ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500'" class="-ml-0.5 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                        </svg>
                        <span> Datové schránky </span>
                    </InertiaLink>

                    <InertiaLink :class="tab === 'settings.ds' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                  :href="route('settings.ds')"
                                  class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm" aria-current="page">

                        <svg :class="tab === 'settings.ds' ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500'" class="-ml-0.5 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                        </svg>
                        <span> Funkce DSchránky </span>
                    </InertiaLink>

                    <InertiaLink :class="tab === 'spark.portal' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                  :href="route('spark.portal')"
                                  class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm">

                        <svg :class="tab === 'spark.portal' ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500'" class="-ml-0.5 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                            <path fill-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clip-rule="evenodd" />
                        </svg>
                        <span> Licence a platby </span>
                    </InertiaLink>

                    <InertiaLink :class="tab === 'settings.notifications' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
                                  :href="route('settings.notifications')"
                                  class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm">


                        <svg :class="tab === 'settings.notifications' ? 'text-indigo-500' : 'text-gray-400 group-hover:text-gray-500'" class="-ml-0.5 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                        </svg>
                        <span> Upozornění a maily </span>
                    </InertiaLink>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    name: "SettingsTabsNavigation",
    components: {
        InertiaLink: Link,
    },

    data(){
        return {
            tab: route().current(),
        }
    },
    methods: {
        changeTab(){
            this.$inertia.get(route(this.tab));
        }
    }
}
</script>

<style scoped>

</style>
